var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.buttonLink)?_c('WpLink',{key:_vm.buttonLink,staticClass:"margin-bottom-lg back-link slide-hover",attrs:{"title":_vm.buttonTitle,"url":_vm.buttonLink}},[_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.getIcon('arrowParent', '#fff'))}}),_c('span',{staticClass:"txt"},[_vm._v(_vm._s(_vm.buttonTitle))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }